
export const PROFILE_IMAGE_URL = process.env.REACT_APP_EMPLOYEE_PROFILE_IMAGE_PATH;
export const LEAVE_FILES_URL = process.env.REACT_APP_LEAVE_FILE_PATH;
export const LEAVE_EXCEL_TEMPLATES_URL = process.env.REACT_APP_LEAVE_EXCEL_TEMPLATE_PATH;
export const SYSTEM_POLICY_FILES_URL = process.env.REACT_APP_SYSTEM_POLICY_FILES_PATH;
export const EMPLOYEE_DOCUMENT_URL = process.env.REACT_APP_EMPLOYEE_DOCUMENT_FILES_PATH;
